export enum TableHeaderTypes {
  IMAGE_WITH_TITLE_DESC = 'imageWithTitleDesc',
  USERNAME = 'userName',
  DATE = 'date',
  TITLECASE = 'titleCase',
  CURRENCY = 'currency',
  PARAGRAPH = 'paragraph',
  AVTARIMAGETEXT = 'avtarImageText',
  IN_ROW_ACTION = 'inRowAction',
  LAST_SESSION = 'lastSession',
  STATUS = 'status',
  STATUS_CHIP = 'statusChip',
  SERIAL = 'serial',
  ICON_COLUMN = 'iconDisplay'
}
export enum ContentPurchaseLabels {
  PURCHASED_FROM = 'Purchased From',
  TYPE = 'Type',
  DATE = 'Date',
  TRANSACTION_ID = 'Transaction ID',
  PRICE = 'Price',
  PURCHASE_DETAIL = 'Details',
  CONTENT_DETAIL = 'Content Detail'
}
